/**
 * Returns "a" or "an" based on whether the word starts with a vowel sound.
 */
export const getArticle = (word: string): string => {
  return /^[aeiou]/i.test(word) ? 'an' : 'a'
}
